import React, { useState, useEffect } from 'react';
import './AdminPanel.css';

interface Category {
  id: string;
  name: string;
  icon: string;
}

interface Product {
  id: number;
  category: string;
  image: string;
  title: string;
  description: string;
  price: string;
  features: string[];
}

interface MediaItem {
  id: string;
  type: 'image' | 'video';
  url: string;
  title: string;
  description: string;
  category: string;
  thumbnail?: string; // Video kapak resmi için
}

interface FAQ {
  id: string;
  question: string;
  answer: string;
  order: number;
}

interface SocialLink {
  id: string;
  name: string;
  url: string;
  icon: string;
}

interface ContentSection {
  id: string;
  title: string;
  description: string;
}

interface AdminPanelProps {
  onClose: () => void;
}

const AdminPanel: React.FC<AdminPanelProps> = ({ onClose }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [activeTab, setActiveTab] = useState<'categories' | 'products' | 'media' | 'faq' | 'social' | 'content'>('categories');
  
  // Categories state
  const [categories, setCategories] = useState<Category[]>([
    { id: 'all', name: 'Tüm Ürünler', icon: '🛍️' },
    { id: 'vip', name: 'VIP Paketleri', icon: '👑' },
    { id: 'money', name: 'Oyun İçi Para', icon: '💰' },
    { id: 'vehicles', name: 'Araçlar', icon: '🚗' },
    { id: 'houses', name: 'Evler', icon: '🏠' },
    { id: 'items', name: 'Özel Eşyalar', icon: '🎁' }
  ]);

  // Products state
  const [products, setProducts] = useState<Product[]>([
    {
      id: 1,
      category: 'vip',
      image: '/gta.png',
      title: 'Bronz VIP',
      description: 'Temel VIP özellikleri',
      price: '₺25',
      features: ['Özel Rozet', 'VIP Chat', '50K Para']
    },
    {
      id: 2,
      category: 'vip',
      image: '/fivem.png',
      title: 'Gümüş VIP',
      description: 'Gelişmiş VIP özellikleri',
      price: '₺50',
      features: ['Gümüş Rozet', 'Premium Chat', '100K Para']
    },
    {
      id: 3,
      category: 'vip',
      image: '/discord.png',
      title: 'Altın VIP',
      description: 'En üst seviye VIP',
      price: '₺100',
      features: ['Altın Rozet', 'Elite Chat', '250K Para']
    }
  ]);

  // Media state
  const [mediaItems, setMediaItems] = useState<MediaItem[]>([
    {
      id: 'main-video',
      type: 'video',
      url: 'https://www.youtube.com/watch?v=example',
      title: 'VISE RP TANITIM VİDEOSU',
      description: 'GTA 5 ROLEPLAY DENEYİMİ',
      category: 'main',
      thumbnail: '/gta.png'
    },
    {
      id: 'gta-thumb',
      type: 'image',
      url: '/gta.png',
      title: 'GTA 5',
      description: 'GTA 5 Thumbnail',
      category: 'video-thumbs'
    },
    {
      id: 'fivem-thumb',
      type: 'image',
      url: '/fivem.png',
      title: 'FiveM',
      description: 'FiveM Thumbnail',
      category: 'video-thumbs'
    },
    {
      id: 'gameplay-thumb',
      type: 'image',
      url: '/gta.png',
      title: 'Gameplay',
      description: 'Gameplay Thumbnail',
      category: 'video-thumbs'
    },
    {
      id: 'city-thumb',
      type: 'image',
      url: '/gta.png',
      title: 'Los Santos',
      description: 'Los Santos Thumbnail',
      category: 'video-thumbs'
    },
    {
      id: 'cars-thumb',
      type: 'image',
      url: '/gta.png',
      title: 'Araçlar',
      description: 'Araçlar Thumbnail',
      category: 'video-thumbs'
    },
    {
      id: 'jobs-thumb',
      type: 'image',
      url: '/gta.png',
      title: 'Meslekler',
      description: 'Meslekler Thumbnail',
      category: 'video-thumbs'
    },
    {
      id: 'discord-social',
      type: 'image',
      url: '/discord.png',
      title: 'Discord',
      description: 'Discord Social Icon',
      category: 'social'
    },
    {
      id: 'youtube-social',
      type: 'image',
      url: '/youtube.png',
      title: 'YouTube',
      description: 'YouTube Social Icon',
      category: 'social'
    },
    {
      id: 'tiktok-social',
      type: 'image',
      url: '/tiktok.png',
      title: 'TikTok',
      description: 'TikTok Social Icon',
      category: 'social'
    },
    {
      id: 'instagram-social',
      type: 'image',
      url: '/insta.png',
      title: 'Instagram',
      description: 'Instagram Social Icon',
      category: 'social'
    },
    {
      id: 'gta-step',
      type: 'image',
      url: '/gta.png',
      title: 'GTA V Step',
      description: 'GTA V Adım Resmi',
      category: 'steps'
    },
    {
      id: 'fivem-step',
      type: 'image',
      url: '/fivem.png',
      title: 'FiveM Step',
      description: 'FiveM Adım Resmi',
      category: 'steps'
    }
  ]);

  // FAQ state
  const [faqs, setFaqs] = useState<FAQ[]>([
    {
      id: '1',
      question: 'GTA V\'de Role Play nedir?',
      answer: 'Role Play, seçilen rolleri oynayarak, kuralları takip ederek ve gerçek hayattaki gibi etkileşim kurarak oynanan popüler bir oyun türüdür.',
      order: 1
    },
    {
      id: '2',
      question: 'VISE RP\'de nasıl başlarım?',
      answer: 'Başlamak için önce GTA V lisansını satın almanız ve ardından VISE Launcher\'ı indirmeniz gerekiyor.',
      order: 2
    },
    {
      id: '3',
      question: 'Sunucuda yeni oyuncu ne yapmalı?',
      answer: 'Yeni oyuncular için temel mekanikleri ve oyun kurallarını öğrenmeye yardımcı olacak eğitim sistemimizi tamamlamanızı öneriyoruz.',
      order: 3
    },
    {
      id: '4',
      question: 'VISE RP rehberleri ve Wiki\'yi nerede bulabilirim?',
      answer: 'Detaylı rehberler, mekanik açıklamaları ve meslek bilgileri resmi Wiki\'mizde - oyuncular için kullanışlı bilgi tabanında toplanmıştır.',
      order: 4
    },
    {
      id: '5',
      question: 'Sunucu kurallarını nerede bulabilirim?',
      answer: 'Sunucu kuralları, oyun içi kurallar ve etkinlik bilgileri forum sayfamızda bulunabilir.',
      order: 5
    },
    {
      id: '6',
      question: 'VISE RP\'ye giriş yapamıyorum?',
      answer: 'Giriş sorunları yaşıyorsanız resmi Discord kanalımızdaki teknik destek ekibimizle iletişime geçmenizi öneriyoruz.',
      order: 6
    }
  ]);

  // Social Links state
  const [socialLinks, setSocialLinks] = useState<SocialLink[]>([
    {
      id: 'discord',
      name: 'Discord',
      url: 'https://discord.gg/ZRPhecHk',
      icon: '💬'
    },
    {
      id: 'youtube',
      name: 'YouTube',
      url: 'https://youtube.com/@viserp',
      icon: '📺'
    },
    {
      id: 'instagram',
      name: 'Instagram',
      url: 'https://instagram.com/viserp',
      icon: '📷'
    },
    {
      id: 'tiktok',
      name: 'TikTok',
      url: 'https://tiktok.com/@viserp',
      icon: '🎵'
    }
  ]);

  // Content Sections state
  const [contentSections, setContentSections] = useState<ContentSection[]>([
    {
      id: 'about',
      title: 'KENDİ YOLUNU ÇİZ',
      description: 'Bu dinamik VISE RP\'de seçim senin; kötü şöhretli bir çete lider ol ya da senaryoyu değiştir ve adaletin savunucusu olmak için güçlere katıl. Suç ve kanun arasındaki ince çizgide gezin, her karar seni yeraltı dünyasının derinliklerine ya da şehrin en cesurlarının saflarına itebilir. Sokakları mı yöneteceksin yoksa onları mı koruyacaksın?'
    }
  ]);

  // Form states
  const [newCategory, setNewCategory] = useState({ id: '', name: '', icon: '' });
  const [newProduct, setNewProduct] = useState({
    category: '',
    image: '',
    title: '',
    description: '',
    price: '',
    features: ['']
  });
  const [newMedia, setNewMedia] = useState({
    id: '',
    type: 'image' as 'image' | 'video',
    url: '',
    title: '',
    description: '',
    category: 'main',
    thumbnail: ''
  });
  const [newFaq, setNewFaq] = useState({
    question: '',
    answer: '',
    order: 1
  });
  const [newSocialLink, setNewSocialLink] = useState({
    name: '',
    url: '',
    icon: ''
  });

  const ADMIN_PASSWORD = 'vise2026admin'; // Admin şifresi

  const handleLogin = () => {
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
    } else {
      alert('Yanlış şifre!');
    }
  };

  const addCategory = () => {
    console.log('addCategory çağrıldı:', newCategory);
    
    if (!newCategory.id) {
      alert('Kategori ID gerekli!');
      return;
    }
    if (!newCategory.name) {
      alert('Kategori adı gerekli!');
      return;
    }
    if (!newCategory.icon) {
      alert('Kategori ikonu gerekli!');
      return;
    }
    
    // ID'nin benzersiz olduğunu kontrol et
    if (categories.find(cat => cat.id === newCategory.id)) {
      alert('Bu ID zaten kullanılıyor!');
      return;
    }
    
    const updatedCategories = [...categories, { ...newCategory }];
    setCategories(updatedCategories);
    
    // LocalStorage'a kaydet
    localStorage.setItem('vise-categories', JSON.stringify(updatedCategories));
    
    // Formu temizle
    setNewCategory({ id: '', name: '', icon: '' });
    
    alert('Kategori başarıyla eklendi!');
    console.log('Güncel kategoriler:', updatedCategories);
  };

  const deleteCategory = (id: string) => {
    if (id === 'all') {
      alert('Tüm Ürünler kategorisi silinemez!');
      return;
    }
    const updatedCategories = categories.filter(cat => cat.id !== id);
    setCategories(updatedCategories);
    localStorage.setItem('vise-categories', JSON.stringify(updatedCategories));
  };

  const addProduct = () => {
    console.log('addProduct çağrıldı:', newProduct);
    
    if (!newProduct.title) {
      alert('Ürün başlığı gerekli!');
      return;
    }
    if (!newProduct.category) {
      alert('Kategori seçimi gerekli!');
      return;
    }
    if (!newProduct.price) {
      alert('Fiyat gerekli!');
      return;
    }

    const product = {
      ...newProduct,
      id: Date.now(),
      features: newProduct.features.filter(f => f.trim() !== '')
    };
    
    console.log('Yeni ürün oluşturuluyor:', product);
    
    const updatedProducts = [...products, product];
    setProducts(updatedProducts);
    
    // LocalStorage'a kaydet
    localStorage.setItem('vise-products', JSON.stringify(updatedProducts));
    
    // Formu temizle
    setNewProduct({
      category: '',
      image: '',
      title: '',
      description: '',
      price: '',
      features: ['']
    });
    
    alert('Ürün başarıyla eklendi!');
    console.log('Güncel ürünler:', updatedProducts);
  };

  const deleteProduct = (id: number) => {
    const updatedProducts = products.filter(prod => prod.id !== id);
    setProducts(updatedProducts);
    localStorage.setItem('vise-products', JSON.stringify(updatedProducts));
  };

  const addMedia = () => {
    console.log('addMedia çağrıldı:', newMedia);
    
    if (!newMedia.id) {
      alert('Medya ID gerekli!');
      return;
    }
    if (!newMedia.title) {
      alert('Medya başlığı gerekli!');
      return;
    }
    if (!newMedia.url) {
      alert('Medya URL gerekli!');
      return;
    }
    
    // ID'nin benzersiz olduğunu kontrol et
    if (mediaItems.find(media => media.id === newMedia.id)) {
      alert('Bu ID zaten kullanılıyor!');
      return;
    }
    
    const media = {
      ...newMedia,
    };
    
    const updatedMedia = [...mediaItems, media];
    setMediaItems(updatedMedia);
    
    // LocalStorage'a kaydet
    localStorage.setItem('vise-media', JSON.stringify(updatedMedia));
    
    // Formu temizle
    setNewMedia({
      id: '',
      type: 'image',
      url: '',
      title: '',
      description: '',
      category: 'main',
      thumbnail: ''
    });
    
    alert('Medya başarıyla eklendi!');
    console.log('Güncel medya:', updatedMedia);
  };

  const deleteMedia = (id: string) => {
    const updatedMedia = mediaItems.filter(media => media.id !== id);
    setMediaItems(updatedMedia);
    localStorage.setItem('vise-media', JSON.stringify(updatedMedia));
  };

  const updateMedia = (id: string, updates: Partial<MediaItem>) => {
    const updatedMedia = mediaItems.map(media => 
      media.id === id ? { ...media, ...updates } : media
    );
    setMediaItems(updatedMedia);
    localStorage.setItem('vise-media', JSON.stringify(updatedMedia));
  };

  const addFeatureField = () => {
    setNewProduct({
      ...newProduct,
      features: [...newProduct.features, '']
    });
  };

  const updateFeature = (index: number, value: string) => {
    const updatedFeatures = [...newProduct.features];
    updatedFeatures[index] = value;
    setNewProduct({
      ...newProduct,
      features: updatedFeatures
    });
  };

  const removeFeature = (index: number) => {
    const updatedFeatures = newProduct.features.filter((_, i) => i !== index);
    setNewProduct({
      ...newProduct,
      features: updatedFeatures
    });
  };

  // FAQ Functions
  const addFaq = () => {
    if (!newFaq.question.trim()) {
      alert('Soru gerekli!');
      return;
    }
    if (!newFaq.answer.trim()) {
      alert('Cevap gerekli!');
      return;
    }

    const faq = {
      id: Date.now().toString(),
      question: newFaq.question.trim(),
      answer: newFaq.answer.trim(),
      order: newFaq.order
    };

    const updatedFaqs = [...faqs, faq].sort((a, b) => a.order - b.order);
    setFaqs(updatedFaqs);

    // LocalStorage'a kaydet
    localStorage.setItem('vise-faqs', JSON.stringify(updatedFaqs));

    // Formu temizle
    setNewFaq({
      question: '',
      answer: '',
      order: faqs.length + 1
    });

    alert('FAQ başarıyla eklendi!');
  };

  const deleteFaq = (id: string) => {
    const updatedFaqs = faqs.filter(faq => faq.id !== id);
    setFaqs(updatedFaqs);
    localStorage.setItem('vise-faqs', JSON.stringify(updatedFaqs));
  };

  const updateFaq = (id: string, updates: Partial<FAQ>) => {
    const updatedFaqs = faqs.map(faq => 
      faq.id === id ? { ...faq, ...updates } : faq
    ).sort((a, b) => a.order - b.order);
    setFaqs(updatedFaqs);
    localStorage.setItem('vise-faqs', JSON.stringify(updatedFaqs));
  };

  // Social Links Functions
  const addSocialLink = () => {
    if (!newSocialLink.name.trim()) {
      alert('Platform adı gerekli!');
      return;
    }
    if (!newSocialLink.url.trim()) {
      alert('URL gerekli!');
      return;
    }
    if (!newSocialLink.icon.trim()) {
      alert('Icon gerekli!');
      return;
    }

    const socialLink = {
      id: newSocialLink.name.toLowerCase().replace(/\s+/g, '-'),
      name: newSocialLink.name.trim(),
      url: newSocialLink.url.trim(),
      icon: newSocialLink.icon.trim()
    };

    const updatedSocialLinks = [...socialLinks, socialLink];
    setSocialLinks(updatedSocialLinks);

    // LocalStorage'a kaydet
    localStorage.setItem('vise-social-links', JSON.stringify(updatedSocialLinks));

    // Formu temizle
    setNewSocialLink({
      name: '',
      url: '',
      icon: ''
    });

    alert('Sosyal medya linki başarıyla eklendi!');
  };

  const deleteSocialLink = (id: string) => {
    const updatedSocialLinks = socialLinks.filter(link => link.id !== id);
    setSocialLinks(updatedSocialLinks);
    localStorage.setItem('vise-social-links', JSON.stringify(updatedSocialLinks));
  };

  const updateSocialLink = (id: string, updates: Partial<SocialLink>) => {
    const updatedSocialLinks = socialLinks.map(link => 
      link.id === id ? { ...link, ...updates } : link
    );
    setSocialLinks(updatedSocialLinks);
    localStorage.setItem('vise-social-links', JSON.stringify(updatedSocialLinks));
  };

  // Content Management Functions
  const updateContentSection = (id: string, updates: Partial<ContentSection>) => {
    const updatedContentSections = contentSections.map(section => 
      section.id === id ? { ...section, ...updates } : section
    );
    setContentSections(updatedContentSections);
    localStorage.setItem('vise-content-sections', JSON.stringify(updatedContentSections));
  };

  // LocalStorage'dan veri yükle
  useEffect(() => {
    const savedCategories = localStorage.getItem('vise-categories');
    const savedProducts = localStorage.getItem('vise-products');
    const savedMedia = localStorage.getItem('vise-media');
    const savedFaqs = localStorage.getItem('vise-faqs');
    const savedSocialLinks = localStorage.getItem('vise-social-links');
    const savedContentSections = localStorage.getItem('vise-content-sections');
    
    if (savedCategories) {
      setCategories(JSON.parse(savedCategories));
    }
    
    if (savedProducts) {
      setProducts(JSON.parse(savedProducts));
    }
    
    if (savedMedia) {
      setMediaItems(JSON.parse(savedMedia));
    }

    if (savedFaqs) {
      setFaqs(JSON.parse(savedFaqs));
    }

    if (savedSocialLinks) {
      setSocialLinks(JSON.parse(savedSocialLinks));
    }

    if (savedContentSections) {
      setContentSections(JSON.parse(savedContentSections));
    }
  }, []);

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-container">
          <h2>🔐 Admin Paneli</h2>
          <p>Sadece yöneticiler erişebilir</p>
          <div className="login-form">
            <input
              type="password"
              placeholder="Admin şifresi"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
            />
            <button onClick={handleLogin}>Giriş Yap</button>
          </div>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-container">
        <div className="admin-header">
          <h1>⚙️ VISE RP Admin Paneli</h1>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="admin-tabs">
          <button 
            className={`tab ${activeTab === 'categories' ? 'active' : ''}`}
            onClick={() => setActiveTab('categories')}
          >
            📂 Kategoriler
          </button>
          <button 
            className={`tab ${activeTab === 'products' ? 'active' : ''}`}
            onClick={() => setActiveTab('products')}
          >
            🛍️ Ürünler
          </button>
          <button 
            className={`tab ${activeTab === 'media' ? 'active' : ''}`}
            onClick={() => setActiveTab('media')}
          >
            🎬 Medya
          </button>
          <button 
            className={`tab ${activeTab === 'faq' ? 'active' : ''}`}
            onClick={() => setActiveTab('faq')}
          >
            ❓ FAQ
          </button>
          <button 
            className={`tab ${activeTab === 'social' ? 'active' : ''}`}
            onClick={() => setActiveTab('social')}
          >
            🔗 Sosyal Medya
          </button>
          <button 
            className={`tab ${activeTab === 'content' ? 'active' : ''}`}
            onClick={() => setActiveTab('content')}
          >
            📝 İçerik
          </button>
        </div>

        {activeTab === 'categories' && (
          <div className="admin-content">
            <div className="add-section">
              <h3>Yeni Kategori Ekle</h3>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Kategori ID (örn: weapons)"
                  value={newCategory.id}
                  onChange={(e) => setNewCategory({...newCategory, id: e.target.value})}
                />
                <input
                  type="text"
                  placeholder="Kategori Adı"
                  value={newCategory.name}
                  onChange={(e) => setNewCategory({...newCategory, name: e.target.value})}
                />
                <input
                  type="text"
                  placeholder="Emoji Icon (örn: 🔫)"
                  value={newCategory.icon}
                  onChange={(e) => setNewCategory({...newCategory, icon: e.target.value})}
                />
                <button onClick={addCategory}>Kategori Ekle</button>
              </div>
            </div>

            <div className="list-section">
              <h3>Mevcut Kategoriler</h3>
              <div className="items-list">
                {categories.map(category => (
                  <div key={category.id} className="item-card">
                    <span className="item-icon">{category.icon}</span>
                    <div className="item-info">
                      <strong>{category.name}</strong>
                      <small>ID: {category.id}</small>
                    </div>
                    {category.id !== 'all' && (
                      <button 
                        className="delete-btn"
                        onClick={() => deleteCategory(category.id)}
                      >
                        🗑️
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'products' && (
          <div className="admin-content">
            <div className="add-section">
              <h3>Yeni Ürün Ekle</h3>
              <div className="form-group">
                <select
                  value={newProduct.category}
                  onChange={(e) => setNewProduct({...newProduct, category: e.target.value})}
                >
                  <option value="">Kategori Seçin</option>
                  {categories.filter(cat => cat.id !== 'all').map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
                
                <input
                  type="text"
                  placeholder="Ürün Başlığı"
                  value={newProduct.title}
                  onChange={(e) => setNewProduct({...newProduct, title: e.target.value})}
                />
                
                <input
                  type="text"
                  placeholder="Resim URL'si (örn: /image.png)"
                  value={newProduct.image}
                  onChange={(e) => setNewProduct({...newProduct, image: e.target.value})}
                />
                
                <textarea
                  placeholder="Ürün Açıklaması"
                  value={newProduct.description}
                  onChange={(e) => setNewProduct({...newProduct, description: e.target.value})}
                />
                
                <input
                  type="text"
                  placeholder="Fiyat (örn: ₺50)"
                  value={newProduct.price}
                  onChange={(e) => setNewProduct({...newProduct, price: e.target.value})}
                />

                <div className="features-section">
                  <label>Özellikler:</label>
                  {newProduct.features.map((feature, index) => (
                    <div key={index} className="feature-input">
                      <input
                        type="text"
                        placeholder={`Özellik ${index + 1}`}
                        value={feature}
                        onChange={(e) => updateFeature(index, e.target.value)}
                      />
                      {newProduct.features.length > 1 && (
                        <button 
                          type="button"
                          onClick={() => removeFeature(index)}
                          className="remove-feature"
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  ))}
                  <button type="button" onClick={addFeatureField} className="add-feature">
                    + Özellik Ekle
                  </button>
                </div>

                <button onClick={addProduct}>Ürün Ekle</button>
              </div>
            </div>

            <div className="list-section">
              <h3>Mevcut Ürünler</h3>
              <div className="items-list">
                {products.map(product => (
                  <div key={product.id} className="item-card product-card">
                    <img src={product.image} alt={product.title} className="product-image" />
                    <div className="item-info">
                      <strong>{product.title}</strong>
                      <small>Kategori: {categories.find(cat => cat.id === product.category)?.name}</small>
                      <small>Fiyat: {product.price}</small>
                    </div>
                    <button 
                      className="delete-btn"
                      onClick={() => deleteProduct(product.id)}
                    >
                      🗑️
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'media' && (
          <div className="admin-content">
            <div className="add-section">
              <h3>Yeni Medya Ekle</h3>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Medya ID (örn: main-video)"
                  value={newMedia.id}
                  onChange={(e) => setNewMedia({...newMedia, id: e.target.value})}
                />
                
                <select
                  value={newMedia.type}
                  onChange={(e) => setNewMedia({...newMedia, type: e.target.value as 'image' | 'video'})}
                >
                  <option value="image">Resim</option>
                  <option value="video">Video</option>
                </select>
                
                <select
                  value={newMedia.category}
                  onChange={(e) => setNewMedia({...newMedia, category: e.target.value})}
                >
                  <option value="main">Ana Video</option>
                  <option value="vip">VIP Paketleri</option>
                  <option value="money">Oyun İçi Para</option>
                  <option value="vehicles">Araçlar</option>
                  <option value="houses">Evler</option>
                  <option value="gameplay">Gameplay</option>
                  <option value="video-thumbs">Video Thumbnails</option>
                  <option value="social">Sosyal Medya</option>
                  <option value="steps">Adım Resimleri</option>
                </select>
                
                <input
                  type="text"
                  placeholder="Medya Başlığı"
                  value={newMedia.title}
                  onChange={(e) => setNewMedia({...newMedia, title: e.target.value})}
                />
                
                <input
                  type="text"
                  placeholder={newMedia.type === 'video' ? 'YouTube URL (örn: https://www.youtube.com/watch?v=...)' : 'Resim URL (örn: /image.png)'}
                  value={newMedia.url}
                  onChange={(e) => setNewMedia({...newMedia, url: e.target.value})}
                />
                
                {newMedia.type === 'video' && (
                  <div className="video-thumbnail-section">
                    <label>📸 Kapak Resmi Seçenekleri:</label>
                    <div className="thumbnail-options">
                      <label className="thumbnail-option">
                        <input
                          type="radio"
                          name="thumbnailType"
                          value="auto"
                          checked={!newMedia.thumbnail || newMedia.thumbnail === 'auto'}
                          onChange={() => setNewMedia({...newMedia, thumbnail: 'auto'})}
                        />
                        <span>🤖 Otomatik (YouTube'dan çek)</span>
                      </label>
                      <label className="thumbnail-option">
                        <input
                          type="radio"
                          name="thumbnailType"
                          value="custom"
                          checked={newMedia.thumbnail !== undefined && newMedia.thumbnail !== 'auto'}
                          onChange={() => setNewMedia({...newMedia, thumbnail: ''})}
                        />
                        <span>📁 Özel Kapak Resmi</span>
                      </label>
                    </div>
                    
                    {newMedia.thumbnail !== undefined && newMedia.thumbnail !== 'auto' && (
                      <input
                        type="text"
                        placeholder="Kapak Resmi URL (örn: /thumbnail.png)"
                        value={newMedia.thumbnail}
                        onChange={(e) => setNewMedia({...newMedia, thumbnail: e.target.value})}
                      />
                    )}
                    
                    {newMedia.url && newMedia.url.includes('youtube.com') && (
                      <div className="thumbnail-preview">
                        <p>🔍 YouTube Thumbnail Önizleme:</p>
                        <img 
                          src={`https://img.youtube.com/vi/${newMedia.url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/)?.[1] || ''}/hqdefault.jpg`}
                          alt="YouTube Thumbnail"
                          className="preview-thumbnail"
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.style.display = 'none';
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
                
                <textarea
                  placeholder="Açıklama"
                  value={newMedia.description}
                  onChange={(e) => setNewMedia({...newMedia, description: e.target.value})}
                />

                <button onClick={addMedia}>Medya Ekle</button>
              </div>
            </div>

            <div className="list-section">
              <h3>Mevcut Medya</h3>
              <div className="media-categories">
                <div className="media-category">
                  <h4>🎬 Videolar</h4>
                  <div className="items-list">
                    {mediaItems.filter(media => media.type === 'video').map(media => (
                      <div key={media.id} className="item-card media-card video-card">
                        <div className="media-preview">
                          {media.thumbnail !== undefined && media.thumbnail !== 'auto' ? (
                            <img src={media.thumbnail} alt={media.title} className="media-thumbnail" />
                          ) : media.url.includes('youtube.com') ? (
                            <img 
                              src={`https://img.youtube.com/vi/${media.url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/)?.[1] || ''}/hqdefault.jpg`}
                              alt={media.title} 
                              className="media-thumbnail"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.src = '/gta.png';
                              }}
                            />
                          ) : (
                            <div className="video-placeholder">🎬</div>
                          )}
                          <div className="video-overlay-small">▶</div>
                        </div>
                        <div className="item-info">
                          <strong>{media.title}</strong>
                          <small>Kategori: {media.category}</small>
                          <small className="url-preview">{media.url.length > 50 ? media.url.substring(0, 50) + '...' : media.url}</small>
                          <small>{media.description}</small>
                        </div>
                        <div className="media-actions">
                          <button 
                            className="edit-btn"
                            onClick={() => {
                              const newUrl = prompt('Yeni YouTube URL:', media.url);
                              if (newUrl) {
                                updateMedia(media.id, { url: newUrl });
                              }
                            }}
                          >
                            ✏️
                          </button>
                          <button 
                            className="thumbnail-btn"
                            onClick={() => {
                              const newThumbnail = prompt('Yeni Kapak Resmi URL (boş bırakın otomatik için):', media.thumbnail || '');
                              if (newThumbnail !== null) {
                                updateMedia(media.id, { thumbnail: newThumbnail || 'auto' });
                              }
                            }}
                          >
                            📸
                          </button>
                          <button 
                            className="delete-btn"
                            onClick={() => deleteMedia(media.id)}
                          >
                            🗑️
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="media-category">
                  <h4>🖼️ Resimler</h4>
                  <div className="items-list">
                    {mediaItems.filter(media => media.type === 'image').map(media => (
                      <div key={media.id} className="item-card media-card">
                        <div className="media-preview">
                          <img src={media.url} alt={media.title} className="media-thumbnail" />
                        </div>
                        <div className="item-info">
                          <strong>{media.title}</strong>
                          <small>Kategori: {media.category}</small>
                          <small className="url-preview">{media.url}</small>
                        </div>
                        <div className="media-actions">
                          <button 
                            className="edit-btn"
                            onClick={() => {
                              const newUrl = prompt('Yeni Resim URL:', media.url);
                              if (newUrl) {
                                updateMedia(media.id, { url: newUrl });
                              }
                            }}
                          >
                            ✏️
                          </button>
                          <button 
                            className="delete-btn"
                            onClick={() => deleteMedia(media.id)}
                          >
                            🗑️
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'faq' && (
          <div className="admin-content">
            <div className="add-section">
              <h3>Yeni FAQ Ekle</h3>
              <div className="form-group">
                <input
                  type="number"
                  placeholder="Sıra (1, 2, 3...)"
                  value={newFaq.order}
                  onChange={(e) => setNewFaq({...newFaq, order: parseInt(e.target.value) || 1})}
                  min="1"
                />
                <textarea
                  placeholder="Soru"
                  value={newFaq.question}
                  onChange={(e) => setNewFaq({...newFaq, question: e.target.value})}
                  rows={2}
                />
                <textarea
                  placeholder="Cevap"
                  value={newFaq.answer}
                  onChange={(e) => setNewFaq({...newFaq, answer: e.target.value})}
                  rows={4}
                />
                <button onClick={addFaq}>FAQ Ekle</button>
              </div>
            </div>

            <div className="list-section">
              <h3>Mevcut FAQ'lar</h3>
              <div className="items-list">
                {faqs.sort((a, b) => a.order - b.order).map(faq => (
                  <div key={faq.id} className="item-card faq-card">
                    <div className="faq-order">#{faq.order}</div>
                    <div className="item-info">
                      <strong>{faq.question}</strong>
                      <p>{faq.answer}</p>
                    </div>
                    <div className="faq-actions">
                      <button 
                        className="edit-btn"
                        onClick={() => {
                          const newQuestion = prompt('Yeni Soru:', faq.question);
                          if (newQuestion) {
                            updateFaq(faq.id, { question: newQuestion });
                          }
                        }}
                      >
                        ✏️
                      </button>
                      <button 
                        className="edit-btn"
                        onClick={() => {
                          const newAnswer = prompt('Yeni Cevap:', faq.answer);
                          if (newAnswer) {
                            updateFaq(faq.id, { answer: newAnswer });
                          }
                        }}
                      >
                        💬
                      </button>
                      <button 
                        className="edit-btn"
                        onClick={() => {
                          const newOrder = prompt('Yeni Sıra:', faq.order.toString());
                          if (newOrder && !isNaN(parseInt(newOrder))) {
                            updateFaq(faq.id, { order: parseInt(newOrder) });
                          }
                        }}
                      >
                        🔢
                      </button>
                      <button 
                        className="delete-btn"
                        onClick={() => deleteFaq(faq.id)}
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'social' && (
          <div className="admin-content">
            <div className="add-section">
              <h3>Yeni Sosyal Medya Linki Ekle</h3>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Platform Adı (örn: Discord, YouTube)"
                  value={newSocialLink.name}
                  onChange={(e) => setNewSocialLink({...newSocialLink, name: e.target.value})}
                />
                <input
                  type="text"
                  placeholder="URL (örn: https://discord.gg/ZRPhecHk)"
                  value={newSocialLink.url}
                  onChange={(e) => setNewSocialLink({...newSocialLink, url: e.target.value})}
                />
                <input
                  type="text"
                  placeholder="Icon Emoji (örn: 💬, 📺, 📷)"
                  value={newSocialLink.icon}
                  onChange={(e) => setNewSocialLink({...newSocialLink, icon: e.target.value})}
                />
                <button onClick={addSocialLink}>Sosyal Medya Linki Ekle</button>
              </div>
            </div>

            <div className="list-section">
              <h3>Mevcut Sosyal Medya Linkleri</h3>
              <div className="items-list">
                {socialLinks.map(link => (
                  <div key={link.id} className="item-card social-card">
                    <div className="social-icon-display">{link.icon}</div>
                    <div className="item-info">
                      <strong>{link.name}</strong>
                      <small className="url-preview">{link.url}</small>
                    </div>
                    <div className="social-actions">
                      <button 
                        className="edit-btn"
                        onClick={() => {
                          const newName = prompt('Yeni Platform Adı:', link.name);
                          if (newName) {
                            updateSocialLink(link.id, { name: newName });
                          }
                        }}
                      >
                        ✏️
                      </button>
                      <button 
                        className="edit-btn"
                        onClick={() => {
                          const newUrl = prompt('Yeni URL:', link.url);
                          if (newUrl) {
                            updateSocialLink(link.id, { url: newUrl });
                          }
                        }}
                      >
                        🔗
                      </button>
                      <button 
                        className="edit-btn"
                        onClick={() => {
                          const newIcon = prompt('Yeni Icon:', link.icon);
                          if (newIcon) {
                            updateSocialLink(link.id, { icon: newIcon });
                          }
                        }}
                      >
                        🎨
                      </button>
                      <button 
                        className="delete-btn"
                        onClick={() => deleteSocialLink(link.id)}
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'content' && (
          <div className="admin-content">
            <div className="content-management">
              <h3>İçerik Yönetimi</h3>
              <div className="content-sections">
                {contentSections.map(section => (
                  <div key={section.id} className="content-section-card">
                    <div className="content-section-header">
                      <h4>{section.id === 'about' ? '📖 Hakkımızda Bölümü' : section.id}</h4>
                    </div>
                    
                    <div className="content-section-body">
                      <div className="form-group">
                        <label>Başlık:</label>
                        <input
                          type="text"
                          value={section.title}
                          onChange={(e) => updateContentSection(section.id, { title: e.target.value })}
                          placeholder="Bölüm başlığı"
                        />
                      </div>
                      
                      <div className="form-group">
                        <label>Açıklama:</label>
                        <textarea
                          value={section.description}
                          onChange={(e) => updateContentSection(section.id, { description: e.target.value })}
                          placeholder="Bölüm açıklaması"
                          rows={6}
                        />
                      </div>
                      
                      <div className="content-actions">
                        <button 
                          className="preview-btn"
                          onClick={() => alert(`Başlık: ${section.title}\n\nAçıklama: ${section.description}`)}
                        >
                          👁️ Önizleme
                        </button>
                        <button 
                          className="reset-btn"
                          onClick={() => {
                            if (window.confirm('Bu bölümü varsayılan içeriğe sıfırlamak istediğinizden emin misiniz?')) {
                              updateContentSection(section.id, {
                                title: 'KENDİ YOLUNU ÇİZ',
                                description: 'Bu dinamik VISE RP\'de seçim senin; kötü şöhretli bir çete lider ol ya da senaryoyu değiştir ve adaletin savunucusu olmak için güçlere katıl. Suç ve kanun arasındaki ince çizgide gezin, her karar seni yeraltı dünyasının derinliklerine ya da şehrin en cesurlarının saflarına itebilir. Sokakları mı yöneteceksin yoksa onları mı koruyacaksın?'
                              });
                            }
                          }}
                        >
                          🔄 Sıfırla
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="content-info">
                <h4>💡 İpuçları:</h4>
                <ul>
                  <li>Başlık kısa ve etkileyici olmalı</li>
                  <li>Açıklama kullanıcıları cezbedecek şekilde yazılmalı</li>
                  <li>Değişiklikler otomatik olarak kaydedilir</li>
                  <li>Önizleme ile içeriği kontrol edebilirsiniz</li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPanel;